// extracted by mini-css-extract-plugin
module.exports = {"container":"orderHistory_container__jbgId","title":"orderHistory_title__PoisW","pagination":"orderHistory_pagination__JR5Ur"};